<ami-dialog-message [setting]="message"></ami-dialog-message>

<pg-point-of-sale-create
  *ngIf="open.create"
  (close)="onCloseCreate()"
></pg-point-of-sale-create>

<pg-point-of-sale-update
  *ngIf="open.update"
  (close)="onCloseUpdate()"
  [row]="itemToUpdate"
></pg-point-of-sale-update>

<ami-table
  [settings]="table.settings"
  [data]="table.data"
  (action)="onReciveAction($event)"
></ami-table>
